// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"84edaf34","320":"021ed33e","453":"8177acd1","808":"4eb107ff","827":"a3ca22aa"}[chunkId] + ".chunk.js";
};